import { render } from "./noteMessage.vue?vue&type=template&id=122afa4b"
import script from "./noteMessage.vue?vue&type=script&lang=js"
export * from "./noteMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__